export const TextDomain = 'alcotest-tt';
